export const setUserLocale = (locale) =>{
    return{
        type:'SET_LOCALE',
        value:locale
    }
};


export const setAvailableLocale = (locales) =>{
    return{
        type:'SET_AVAILABLE_LOCALE',
        value:locales
    }
};

export const setGlobalNavLocale = (locale) =>{
    return{
        type:'SET_NAV_LOCALE',
        value:locale
    }
};

export const setGoUrlLocale = (locale) =>{
    return{
        type:'SET_GO_URL_LOCALE',
        value:locale
    }
}

export const setLocaleStatus = (flag) =>{
    return{
        type:'SET_LOCALE_STATUS',
        value:flag
    }
}

